let config = {}

const production = {
  DOMAIN: 'https://sahet.co',
  GRAPHQL: {
    uri: 'https://db.sahet.co/graphql',
    uri_bassica: 'https://db.bassica.co/graphql',
    defaultOptions: {
      query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all'
      },

      mutate: {
        errorPolicy: 'all'
      }
    }
  },
  SOCKETIO: {
    connection: 'https://db.sahet.co'
  },
  IMAGES: {
    path: 'https://sahet-cdn.b-cdn.net/img',
    noImagePathArticle: 'https://sahet-cdn.b-cdn.net/img/others/article-example.png',
    noImagePathMethod: 'https://sahet-cdn.b-cdn.net/img/others/method-example.png',
    noImagePathProduct: 'https://sahet-cdn.b-cdn.net/img/others/product-example.jpg',
    noImagePathConveyor: 'https://sahet-cdn.b-cdn.net/img/others/conveyor-example.png'
  },
  SOUNDS: {
    path: 'https://sahet-cdn.b-cdn.net/sounds'
  }
}

const dev = {
  DOMAIN: 'http://localhost:8080',
  GRAPHQL: {
    uri: 'http://localhost:3000/graphql',
    uri_bassica: 'http://localhost:3000/graphql',
    defaultOptions: {
      query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all'
      },

      mutate: {
        errorPolicy: 'all'
      }
    }
  },
  SOCKETIO: {
    connection: 'http://localhost:3000/'
  },
  IMAGES: {
    path: 'http://127.0.0.1:5501/img',
    noImagePathArticle: 'http://127.0.0.1:5501/img/others/article-example.png',
    noImagePathMethod: 'http://127.0.0.1:5501/img/others/method-example.png',
    noImagePathProduct: 'http://127.0.0.1:5501/img/others/product-example.jpg',
    noImagePathConveyor: 'http://127.0.0.1:5501/img/others/conveyor-example.png'
  },
  SOUNDS: {
    path: 'http://127.0.0.1:5501/sounds'
  }
}

if (process.env.NODE_ENV === 'production') {
  config = production
} else {
  if (process.env.IMAGES === 'production') dev.IMAGES = production.IMAGES
  if (process.env.SOUNDS === 'production') dev.SOUNDS = production.SOUNDS
  config = dev
}

export default config



// WEBPACK FOOTER //
// ./src/config/index.js